import React, { useEffect, useState } from "react";
import Header from "../../sharedScreens/Header";
import HotelInfoCard from "../../components/composite/hotelBookingHistoryDetailCard/HotelInfoCard";
import GuestInfoCard from "../../components/composite/hotelBookingHistoryDetailCard/GuestInfoCard";
import PaymentSummaryCard from "../../components/composite/hotelBookingHistoryDetailCard/PaymentSummaryCard";
import { useLocation } from "react-router-dom";
import { HotelServices } from "../../services/hotelSearch/HotelSearchService";

const HotelBookingHistoryDetail = () => {
  const param = useLocation();
  const item = param.state;
  const id = item?.emt_common_id;
  const [data, setData] = useState<any>(null);
  const getHotelInfo = async (id: string) => {
    const payload = {
      AgentCode: "14",
      HotelID: null,
      EMTCommonID: "EMTHOTEL-4521578",
      EngineID: 10,
      UserName: "HotelAPIUserTest",
      Password: "hotelapitest6NKHbRNN4pSD9G2H",
    };
    const res = await HotelServices.gethoteldetails(payload);
    const finalData = {
      ...item,
      ...res?.data,
    };
    setData(finalData);
  };

  useEffect(() => {
    getHotelInfo(id);
  }, []);

  return (
    <div className="grow">
      <div className="wrapper flex grow flex-col">
        <Header />
      </div>

      <main className="grow content" id="content" role="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-9 col-sm-12">
              <HotelInfoCard data={data} />
            </div>
            <div className="col-md-3">
              <div className="sticky-sidebar">
                <PaymentSummaryCard data={data} />
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-12">
              <GuestInfoCard data={data} />
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default HotelBookingHistoryDetail;
